import { render, staticRenderFns } from "./EmailDomain.vue?vue&type=template&id=60af07e8&"
import script from "./EmailDomain.vue?vue&type=script&lang=js&"
export * from "./EmailDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports